import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment.local';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor(private http: HttpClient) { }

  async getNoti() {
    let notis;
    // http://localhost:1337/api/nuevaope/getNoti
    notis = await this.http.get(`${environment.backendUrl}/api/nuevaope/getNoti`)
    .subscribe((datos: any[]) => {
      if ( datos ) {
        notis = datos[0]['cantid'];
        console.log('notisGLOBAL:', notis);
        return notis;
      } else {
        // console.warn("NO HAY");
        return '0';
      }
    });
  }

  // tslint:disable-next-line: member-ordering
  notis;

  async cargarNotis(){
    let result = 'lacdtm';

    await this.http.get(`${environment.backendUrl}/api/nuevaope/getNoti`)
    .subscribe((datos: any[]) => {
      if ( datos ) {
        result = datos[0]['cantid'];
        localStorage.setItem('global_cantidad', result);
      } else {
        // console.warn("NO HAY");
        result = '0';
        localStorage.setItem('global_cantidad', '0');
      }
      return result.toString();
    });

  }



}
